import React from 'react';
import { Colors } from '../../../constants/Colors.js';

/**
 * Fila de indicadores. items: [{ label, value, hint, color }]
 */
const UsoSirioKpis = ({ items }) => (
  <div className="row mb-3">
    {items.map((item, i) => (
      <div className="col-6 col-md" key={i}>
        <div className="card-dashboard h-100" style={{ padding: 16, marginBottom: 12 }}>
          <div style={{ display: 'block' }}>
            <span className="d-block" style={{ fontSize: 28, lineHeight: 1.2, fontWeight: 600, color: item.color || Colors.neutral_800 }}>
              {item.value}
            </span>
            <span className="d-block font-lato-normal-500" style={{ fontSize: 13, color: Colors.gray_base }}>
              {item.label}
            </span>
            {item.hint && (
              <small className="d-block mt-1" style={{ fontSize: 11, color: Colors.neutral_400 }}>
                {item.hint}
              </small>
            )}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default UsoSirioKpis;
